document.addEventListener('click', async function (e) {
  const swatch = e.target.closest('.swatch-custom-image.swatch-group-selector');
  if (!swatch) return;

  const card = swatch.closest('.product-card');
  if (!card) { /*console.log('No card found');*/ return; }

  const swatchUrl = swatch.getAttribute('swatch-url');
  const handle = swatchUrl?.split('/products/')[1]?.split('?')[0];
  if (!handle) { /*console.log('No handle');*/ return; }

  /*console.log('Fetching:', handle);*/

  try {
    const res = await fetch(`/products/${handle}.js`);
    /*console.log('Fetch status:', res.status);*/
    if (!res.ok) return;
    const product = await res.json();
    /*console.log('Product price:', product.variants[0].price, 'compare:', product.variants[0].compare_at_price);*/

    updatePrice(card, product.variants[0], product);
    updateBadge(card, product.variants[0]);
  } catch (err) {
    /*console.error('Fetch error:', err);*/
  }
}, true);

// function formatMoney(cents) {
//   return (cents / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
// }
function formatMoney(cents) {
  const currency = Shopify.currency.active;

  return (cents / 100).toLocaleString(undefined, {
    style: 'currency',
    currency
  });
}

function updatePrice(card, variant, product) {
  const wrapper = card.querySelector('.f-price');
  if (!wrapper) { /*console.log('No price wrapper'); */ return; }

  const price = variant.price;
  const comparePrice = variant.compare_at_price;
  const onSale = comparePrice && comparePrice > price;

  wrapper.classList.toggle('f-price--on-sale', onSale);

  let moneyPrice = formatMoney(price);
  if (product.price_varies) moneyPrice = 'From ' + moneyPrice;

  const regularItem = wrapper.querySelector('.f-price__regular .f-price-item--regular');
  if (regularItem) regularItem.textContent = moneyPrice;

  const saleItem = wrapper.querySelector('.f-price__sale .f-price-item--sale');
  if (saleItem) saleItem.textContent = moneyPrice;

  const struckItem = wrapper.querySelector('.f-price__sale s.f-price-item--regular');
  if (struckItem) struckItem.textContent = onSale ? formatMoney(comparePrice) : '';
}

function updateBadge(card, variant) {
  const badgeWrapper = card.querySelector('.product-card__badge');
  const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

  if (!badgeWrapper) return;
  let saleBadge = badgeWrapper.querySelector('.f-badge--sale');

  if (onSale && !saleBadge) {
    saleBadge = document.createElement('span');
    saleBadge.className = 'f-badge f-badge--sale';
    saleBadge.textContent = 'Sale';
    badgeWrapper.appendChild(saleBadge);
  } else if (!onSale && saleBadge) {
    saleBadge.remove();
  }
}